import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from '../src/pages/home/homePage';
import LoginPage from '../src/pages/login/loginPage';
import RegisterPage from './pages/registration/registrationPage';
import PickupForm from './pages/handle-Bulk-Pickups/handleBulkPickupPage';
import VerifyOtp from './pages/verify-otp/verifyOtpPage';
import DashboardPage from './pages/dashboard/dashboard';
import AboutUsPage from './pages/about/aboutUsPage';
import TermsOfUsePage from './pages/terms&conditions/termsOfUsePage';
import ShipmentPolicyPage from './pages/terms&conditions/shipmentPolicyPage';
import PrivacyAndCookiesPage from './pages/terms&conditions/privacy&CookiesPage';
import CancellationPolicyPage from './pages/terms&conditions/cancellationPolicyPage';
import SellNowPage from './pages/sell-now/sellNowPage';
import CartPage from './pages/cart/cartPage';
import AddressPage from './pages/address/addressPage';
import OrderSummaryPage from './pages/orderSummary/orderSummaryPage';
import ProfilePage from './pages/UserProfile/userProfileUpdatePage';
import UpdateAddressPage from './pages/address/upadteAddressPage';
import FaqPage from './pages/faq/faqPage';
import ContactUsPage from './pages/contactUs/contactUs';
import ProductDetailPage from './pages/sell-now/productDetailPage';
import ProductDetailPageSame from './pages/sell-now/productSelectionPage';
import ExchangeHomePage from './exchangePages/home/homePage';
import ProductFormPage from './exchangePages/productdetails/productform';
import PersonalInfoFormPage from './exchangePages/personalDetails/personalDetailPage';
import VerifyRegistrationOtp from './exchangePages/verify-otp/verifyRegistrationOtpPage';
import SummaryPage from './exchangePages/exchange-summary/exchangeSummaryPage';
import ThankyouPage from './exchangePages/thanks-page/thankyouPage';
import VerifyExchangeOtp from './exchangePages/verify-otp/verifyOtpPage';
import NotFoundPage from './pages/notFound/notFoundPage';
import OrderThankyouPage from './pages/orderSummary/orderThankYouPage';

// import ReferralsList from './pages/referrals/referralsPage';

const App: React.FC = () => {
  return (
    <Router>
      
      <Routes>
        <Route path="/" element={<HomePage />}/>
        <Route path="/login" element={<LoginPage />}/>
        <Route path="/register" element={<RegisterPage />}/>
        <Route path="/bulk-pickup" element={<PickupForm />}/>
        <Route path = "/verify-otp" element={<VerifyOtp />}/>
        <Route path = "/dashboard" element={<DashboardPage/>}/>
        <Route path = "/about-us" element={<AboutUsPage/>}/>
        <Route path = "/order-submit" element={<OrderThankyouPage/>}/>
        <Route path = "/terms-and-conditions" element={< TermsOfUsePage/>}/>
        <Route path = "/shipping-policy" element={< ShipmentPolicyPage/>}/>
        <Route path = "/privacy-policy" element={< PrivacyAndCookiesPage/>}/>
        <Route path = "/cancellation-policy" element={< CancellationPolicyPage/>}/>
        <Route path="/product-detail-same" element={<ProductDetailPage />}/>
        <Route path="/:product-slug" element={<ProductDetailPageSame />}/>
        <Route path="/sell-used-appliances" element={<SellNowPage />} />
        <Route path="/sell-used/:category" element={<SellNowPage />} />
        <Route path = "/cart/listing" element={<CartPage/>}/>
        <Route path = "/address" element={<AddressPage/>}/>
        <Route path = "/order-summary" element={<OrderSummaryPage/>}/>
        <Route path = "/profile" element={<ProfilePage/>}/>
        <Route path = "/update-address" element={<UpdateAddressPage/>}/>
        <Route path = "/faq" element={<FaqPage/>}/>
        <Route path = "/contact-us" element={<ContactUsPage/>}/>

        {/* <Route path = "/referrals" element={<ReferralsList/>}/> */}
        <Route path="/exchange/program/:prog_id" element={<ExchangeHomePage />} />
        {/* <Route path="/exchange/program/program/:prog_id" element={<ThankyouPage />} /> */}
        <Route path="/login" element={<LoginPage />}/>
        <Route path="exchange/product-form" element={<ProductFormPage />}/>
        <Route path="exchange/personalInfoForm" element={<PersonalInfoFormPage />}/>
        <Route path="exchange/verify-otp" element={<VerifyExchangeOtp />}/>
        <Route path="/verify-registration-otp" element={<VerifyRegistrationOtp />}/>
        <Route path="/exchange/ordersummary" element={<SummaryPage />} />
        <Route path="/exchange/programechangesubmit" element={<ThankyouPage />} />
        {/* Catch all unmatched routes and display the 404 page */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default App;


// sessionStorage.removeItem('session_code');
// setSessCode(null);